// extracted by mini-css-extract-plugin
export default {"wrap":"modal_wrap__p20kk","card":"modal_card__QGsx0","body":"modal_body__QZwUK","closeButton":"modal_closeButton__8aAoV","title":"modal_title__SwWs5"};